'use client';

import React from 'react';

interface Props {
  shown: number;
  total: number;
  onLoadMore: () => void;
  label?: string;
  /** True while the dataset is still topping up — there is nothing more to reveal yet. */
  disabled?: boolean;
}

/**
 * "Load More" button for the SSR grid. The first batch is rendered server-side; this reveals the next
 * one on the client. `total` is the WHOLE listing, so the button appears from first paint rather than
 * after the dataset top-up lands. Hidden once every tile is shown.
 */
const SsrLoadMore: React.FC<Props> = ({ shown, total, onLoadMore, label = 'Load More', disabled = false }) => {
  if (shown >= total) return null;

  return (
    <div className="mt-32 flex w-full justify-center">
      <button
        type="button"
        onClick={onLoadMore}
        disabled={disabled}
        className="cursor-pointer disabled:cursor-default disabled:opacity-60 border border-[#090909] px-32 py-12 text-16 font-medium text-[#090909] transition-colors hover:bg-[#090909] hover:text-white"
      >
        {label}
      </button>
    </div>
  );
};

export default SsrLoadMore;
